import React, { FC } from 'react';

// Components
import { Icon, Tooltip } from 'common/components';

// Models
import { Position, TooltipVariant } from 'common/enums';
import { ErrorData } from 'common/models/data/error.model';

// Assets
import { ICON_COLLECTION } from 'assets/media/icons';

import './ErrorCellRenderer.scss';

type ErrorCellRendererProps = {
    data: any;
};

const ErrorCellRenderer: FC<ErrorCellRendererProps> = ({ data }: ErrorCellRendererProps) => {
    return (
        <div className="error-cell">
            {data.isErrorFixed && !data.childHasError ? (
                <Icon className="error-cell-icon-fixed" src={ICON_COLLECTION.IC_Success_Outlined} />
            ) : data.childHasError ? (
                <div className="info-with-more-wrapper" data-testid={'has-child-error'}>
                    <Icon className="error-cell-icon info-icon" src={ICON_COLLECTION.IC_Info} />
                    <Icon
                        className="error-cell-icon more-icon"
                        src={ICON_COLLECTION.IC_ExpandMore}
                    />
                </div>
            ) : (
                data.errors?.length > 0 && (
                    <Tooltip
                        contentClassName="error-tooltip"
                        placement={Position.Right}
                        trigger={
                            data.errors ? (
                                <Icon
                                    className="error-cell-icon default"
                                    src={ICON_COLLECTION.IC_Info}
                                />
                            ) : (
                                ''
                            )
                        }
                        hideCloseButton={true}
                        allowHover={true}
                        allowClick={false}
                        variant={TooltipVariant.Alt}>
                        <div className="error-tooltip-details">
                            <ol>
                                {data.errors?.map((item: ErrorData | any, index: number) => (
                                    <li key={`${item.columnName}_${index}`}>{item.ruleName}</li>
                                ))}
                            </ol>
                        </div>
                    </Tooltip>
                )
            )}
        </div>
    );
};
export default ErrorCellRenderer;
